import React from "react";
import { useClasses } from "../";
const styes = (theme) => ({
    seperator: { height: "1px", backgroundColor: theme.palette.get("grey") },
});
export default function Seperator() {
    const classes = useClasses(styes);
    return React.createElement("div", { className: classes.seperator });
}
